Namespace 'ScheduledReportResults'

class ScheduledReportResults.ScheduledReportResultView extends Backbone.View
  template: JST['backbone/templates/scheduled_report_result']
  tagName: 'tr'
  className: 'scheduled-report-result-row'

  initialize: (result) ->
    @result = result

  render: ->
    @$el.html @template({
      createdAt: @result.attributes.created_at,
      updatedAt: @result.attributes.updated_at,
      description: @result.attributes.report_description,
      configuration: @result.attributes.serialized_report_configuration,
      resultFileUrl: @result.attributes.result_file_url,
      error_message: @result.attributes.error_message
      linkTranslation: I18n.t('customer.reports.results.link')
      iconClassName: if @result.hasFailed() then 'fa-times' else 'fa-check'
    })

    @
